(function(){
  // mobile menu
  var mt=document.querySelector('[data-menu-toggle]'),nav=document.querySelector('[data-nav]');
  if(mt&&nav){mt.addEventListener('click',function(){var o=nav.classList.toggle('is-open');mt.setAttribute('aria-expanded',o)})}

  // quantity steppers
  document.querySelectorAll('[data-qty]').forEach(function(w){
    var i=w.querySelector('input'),min=parseInt(i.min||'1',10);
    w.querySelector('[data-qty-minus]').addEventListener('click',function(){i.value=Math.max(min,(parseInt(i.value,10)||1)-1);i.dispatchEvent(new Event('change',{bubbles:true}))});
    w.querySelector('[data-qty-plus]').addEventListener('click',function(){i.value=(parseInt(i.value,10)||0)+1;i.dispatchEvent(new Event('change',{bubbles:true}))});
  });
  // cart auto-update
  var cf=document.querySelector('[data-cart-form]');
  if(cf){var t;cf.querySelectorAll('[data-autosubmit]').forEach(function(i){i.addEventListener('change',function(){clearTimeout(t);t=setTimeout(function(){var h=document.createElement('input');h.type='hidden';h.name='update';h.value='1';cf.appendChild(h);cf.submit()},500)})})}

  // gallery
  var g=document.querySelector('[data-gallery]');
  if(g){
    var slides=g.querySelectorAll('[data-slide]'),thumbs=g.querySelectorAll('[data-thumb]');
    thumbs.forEach(function(th){th.addEventListener('click',function(){
      var n=th.getAttribute('data-thumb');
      slides.forEach(function(s){var on=s.getAttribute('data-slide')===n;s.classList.toggle('is-active',on);var v=s.querySelector('video');if(v&&!on)v.pause()});
      thumbs.forEach(function(x){x.classList.toggle('is-active',x===th)});
    })});
  }

  // variant price swap
  var vs=document.querySelector('[data-variant-select]');
  if(vs){vs.addEventListener('change',function(){
    var o=vs.options[vs.selectedIndex];
    var p=document.querySelector('[data-price]'),c=document.querySelector('[data-compare]'),pp=document.querySelector('[data-prepaid]'),m=document.querySelector('[data-price-mini]');
    if(p)p.textContent=o.dataset.price;if(m)m.textContent=o.dataset.price;if(pp)pp.textContent=o.dataset.prepaid;
    if(c){c.textContent=o.dataset.compare;c.hidden=!o.dataset.compare}
  })}

  // sticky add-to-cart on mobile
  var bar=document.querySelector('[data-sticky-atc]'),row=document.querySelector('.buyrow');
  if(bar&&row&&'IntersectionObserver' in window){
    new IntersectionObserver(function(e){bar.classList.toggle('is-visible',!e[0].isIntersecting&&e[0].boundingClientRect.top<0)}).observe(row);
  }
})();

// scroll reveal
(function(){
  var sel='.section__head,.card,.offer,.spots div,.giftbanner>*,.story>*,.about__hero,.about__grid>*,.about__values div,.faq,.trust__grid div,.promise div,.perk';
  var els=document.querySelectorAll(sel);
  if(!('IntersectionObserver' in window)){return}
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{threshold:.12,rootMargin:'0px 0px -40px 0px'});
  els.forEach(function(el,i){el.classList.add('reveal');el.style.transitionDelay=((i%4)*90)+'ms';el.addEventListener('transitionend',function f(e){if(e.propertyName==='opacity'){el.style.transitionDelay='';el.classList.add('done');el.removeEventListener('transitionend',f)}});io.observe(el)});
})();

// login tabs + address delete
(function(){
  document.querySelectorAll('[data-tabs]').forEach(function(w){
    w.querySelectorAll('[data-tab]').forEach(function(b){b.addEventListener('click',function(){
      var k=b.getAttribute('data-tab');
      w.querySelectorAll('[data-tab]').forEach(function(x){x.classList.toggle('is-active',x===b)});
      document.querySelectorAll('[data-tabpanel]').forEach(function(p){p.hidden=p.getAttribute('data-tabpanel')!==k});
    })});
  });
  document.querySelectorAll('[data-delete-address]').forEach(function(b){b.addEventListener('click',function(){
    if(!confirm('Delete this address?'))return;
    var t=document.querySelector('input[name="authenticity_token"]');
    var f=document.createElement('form');f.method='post';f.action=b.getAttribute('data-delete-address');
    [['_method','delete'],['authenticity_token',t?t.value:'']].forEach(function(p){var i=document.createElement('input');i.type='hidden';i.name=p[0];i.value=p[1];f.appendChild(i)});
    document.body.appendChild(f);f.submit();
  })});
})();
